module.exports = __webpack_public_path__ + "media/components/theme/fonts/GTPressuraMono-f405d4d14900087d5e2c8b6311206466.ttf";